<template>
  <div style="margin-top:10px;">      
        <table class="sig">
                    <thead>
                         <tr>
                            <th>AC</th>
                            <th>AL</th>
                            <th>AP</th>
                            <th>AM</th>
                            <th>BA</th>
                            <th>CE</th>
                            <th>DF</th>
                            <th>ES</th>
                            <th>GO</th>
                            <th>MA</th>
                            <th>MT</th>
                            <th>MS</th>
                            <th>MG</th>
                            <th>PA</th>
                            <th>PB</th>
                            <th>PR</th>
                            <th>PE</th>
                            <th>PI</th>
                            <th>RJ</th>
                            <th>RN</th>
                           <th>RS</th> 
                           <th>RO</th>
                           <th>RR</th>
                           <th>SC</th>
                           <th>SP</th>
                           <th>SE</th>
                           <th>TO</th>
                        </tr>
                    </thead>
                    <tbody class="signatarios">
                        <tr>
                            <td v-for="(es,i) in estados" :key="i"> 
                                {{ es.estado.toTo }}
    <div v-if="$route.params.uf == es.estado.toUpperCase()" class="vem"></div>
    <div class="hover-info" style="border: 2px solid rgb(74, 74, 73); position: relative; height: 21px; width:19px;" v-else>
        <img src="/sandboxfront/mapatributario/c.svg" v-if="es.baseLegal != null">
        <img src="/sandboxfront/mapatributario/x.svg" v-else>  
        <div class="hover-text" v-if="es.baseLegal != null">
            <div v-for="(s,a) in es.baseLegal" :key="a">
                {{ s }}
            </div>
            </div> 
    </div>
                                                       
</td>                         
                        </tr>
                            
                            
                    </tbody>
                </table>
  </div>
</template>

<script>
export default {
    props:['estados']
}
</script>

<style>
.vem{
    width: 100%;
    height: 7px;
    background: #000;
}
.hover-text {
    display: none;
    position: absolute;
    top: 20px;
    left: 0;
    background-color: white;
    padding: 5px;
  
    width: 200px;
    max-width: 300px;
    border-radius: 5px;
    z-index: 1;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}

.hover-info:hover > .hover-text {
    display: block;
    text-align: center;
}
table.sig {
    width: 100%;
    border-collapse: collapse;
    font-size: 15px;
    background: #F5F5F5;
}
table.sig td,th{
 border: 1px solid #030303;  
  padding: 8px;
}
table.sig img{
    width: 20px;
    top: -4px;
    position: absolute;
}
</style>